import React from 'react'
import { Link } from 'react-router-dom';
import Service_1 from '../../../assets/images/services/service-four-btn.svg';

const Service = () => {
    return (
        <>
            <div className="service-section-four">
                <div className="container">
                    <div className="heading-box-two">
                        <div className="heading-box">
                            <span
                                className="sub-title animate fadeInUp wow"
                                data-wow-duration="1500ms"
                            >
                                Services
                            </span>
                            <h2
                                className="heading-title animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                We Always Provide Best Services to Our Customers
                            </h2>
                        </div>
                        <Link
                            to="#"
                            className="btn btn-secondary btn-theme animate fadeInUp wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="200ms"
                        >
                            View More Services <span>+</span>
                        </Link>
                    </div>
                    <div className="row gutter-y-30 gutter-x-15">
                        <div className="col-lg-6">
                            <div
                                className="service-box-four animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="service-details-four">
                                    <h4>Business Analysis</h4>
                                    <p>
                                        Consulting services give access to more experienced levels of
                                        expertise than would be feasible to retain in house.
                                    </p>
                                    <Link to="/ServiceDetails" className="service-btn-four">
                                        <img
                                            src={Service_1}
                                            alt="icon"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="service-box-four animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <div className="service-details-four">
                                    <h4>HR Management</h4>
                                    <p>
                                        Results driven marketing campaigns are deployed to achieve
                                        client’s objectives. A strong return on investment is the main
                                        goal
                                    </p>
                                    <Link to="/ServiceDetails" className="service-btn-four">
                                        <img
                                            src={Service_1}
                                            alt="icon"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="service-box-four animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="service-details-four">
                                    <h4>Innovative Technology</h4>
                                    <p>
                                        Quality and experienced design &amp; development services to
                                        start, manage, and grow Internet websites and infrastructures.
                                    </p>
                                    <Link to="/ServiceDetails" className="service-btn-four">
                                        <img
                                            src={Service_1}
                                            alt="icon"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="service-box-four animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="800ms"
                            >
                                <div className="service-details-four">
                                    <h4>Digital Marketing</h4>
                                    <p>
                                        Being a prominent retail digital marketing company, we offer a
                                        variety of services to retail brands. We help our clients create.
                                    </p>
                                    <Link to="/ServiceDetails" className="service-btn-four">
                                        <img
                                            src={Service_1}
                                            alt="icon"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Service
